import Rollbar from "rollbar";
import config from "@/../rollbar.config";
import { SessionHelper } from "./sessionHelper";

config.ignoredMessages = ["Request failed with status code 401"];

// Without a token Rollbar cannot report anything, so stay out of the way entirely
// rather than installing handlers that swallow errors and send them nowhere.
const enabled = !import.meta.env.DEV && Boolean(config.accessToken);

const rollbar = enabled ? new Rollbar(config) : null;

export default {
  install(app) {
    if (enabled) {
      app.config.errorHandler = (error, vm, info) => {
        rollbar.error(error, { info, user: SessionHelper.userId });
        if (app.config.devtools) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      };
      app.provide("rollbar", rollbar);

      app.config.warnHandler = msg => {
        if (app.config.devtools) {
          // eslint-disable-next-line no-console
          console.warn(msg);
        }
      };
    }
  }
};
